import { NotificationItem } from './notification-panel.component';
import { prepareNotificationForDisplay } from '../notification-message/notification-prepare';
import { notificationSenderName } from '../notification-message/notification-sender';
import { notificationAvatar } from '../notification-message/notification-avatar';

/** "9m ago", "2h ago", "Yesterday", "Apr 11" — matches the mock copy style. */
function formatRelative(input: string | number | Date | null | undefined): string {
  if (input == null || input === '') return '';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return '';

  const now = Date.now();
  const diffMs = now - d.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;

  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);
  if (d >= startOfYesterday && d < startOfToday) return 'Yesterday';

  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${months[d.getMonth()]} ${d.getDate()}`;
}

export function mapNotification(n: any): NotificationItem {
  // Relative time is derived from the raw ISO timestamp, BEFORE the page's
  // pre-processing rewrites notifyTime into a display string.
  const time = formatRelative(n?.notifyTime);
  // Work on a copy so the caller's payload isn't mutated; the message
  // template expects the same massaged record the /notifications page renders.
  const raw = prepareNotificationForDisplay({
    ...n,
    notifyData: n?.notifyData ? { ...n.notifyData } : n?.notifyData,
  });
  return {
    id: n?.notifyId || '',
    title: notificationSenderName(raw),
    avatar: notificationAvatar(raw),
    time,
    unread: n?.read === false,
    raw,
  };
}

export function mapNotifications(list: any[] | null | undefined): NotificationItem[] {
  if (!Array.isArray(list)) return [];
  return list.map(mapNotification);
}
